import React from 'react';

import FunctionalTestIds from 'constants/FunctionalTestIds';
import PropTypes from 'prop-types';

class FunctionalTestTarget extends React.Component {
  render() {
    const childrenArray = React.Children.toArray(this.props.children);

    if (childrenArray.length > 1) {
      throw new Error(
        'FunctionalTestTarget only accepts a single child element',
      );
    }

    return React.cloneElement(childrenArray[0], {
      'data-functional-test-id': this.props.id,
    });
  }
}

export const FUNCTIONAL_TEST_IDS = FunctionalTestIds;

FunctionalTestTarget.propTypes = {
  id: PropTypes.oneOf(Object.values(FunctionalTestIds)).isRequired,
};

export default FunctionalTestTarget;
